const e=({cookieName:e,cookieValue:t,validUntilDate:o})=>{const n=o.toUTCString();return`${e}=${encodeURIComponent(t)}; Expires=${n}; Secure; HttpOnly; SameSite=Strict; Path=/`};export{e as getCookieSecuredValueWithExpiration};
